import { useState } from 'react';
import { useApp } from '../context/AppContext';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '../components/Modal';

const COLORS = ['#C8401E','#1C5FAD','#1A7A4A','#5B3E9E','#B8720A','#1A3A5C','#7A1E00'];

export default function AddCustomerModal() {
  const { modals, closeModal, addCustomer, customers, showToast } = useApp();
  const open = modals['add-customer'];

  const [form, setForm] = useState({
    fname:'', lname:'', phone:'', email:'', address:'', passport:'',
    licence:'', licExpiry:'', nationality:'', notes:'', color: COLORS[0],
  });

  function F(k) { return { value: form[k] || '', onChange: e => setForm(p => ({ ...p, [k]: e.target.value })) }; }

  function submit() {
    if (!form.fname || !form.lname) { showToast('First and last name are required'); return; }
    const id = 'C-' + String(customers.length + 1).padStart(3,'0');
    addCustomer({ ...form, id, since: new Date().toLocaleDateString('en-GB',{month:'short',year:'numeric'}) });
    closeModal('add-customer');
    showToast(`✓ Customer ${form.fname} ${form.lname} added`);
    setForm({ fname:'', lname:'', phone:'', email:'', address:'', passport:'', licence:'', licExpiry:'', nationality:'', notes:'', color: COLORS[0] });
  }

  if (!open) return null;

  return (
    <Modal open={!!open} onClose={() => closeModal('add-customer')}>
      <ModalHeader
        title="Add Customer"
        subtitle="Add a new customer to your CRM"
        onClose={() => closeModal('add-customer')}
      />
      <ModalBody>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div className="fg"><label className="fl">First name</label><input type="text" className="fi" {...F('fname')} /></div>
            <div className="fg"><label className="fl">Last name</label><input type="text" className="fi" {...F('lname')} /></div>
            <div className="fg"><label className="fl">Phone</label><input type="text" className="fi" {...F('phone')} /></div>
            <div className="fg"><label className="fl">Email</label><input type="email" className="fi" {...F('email')} /></div>
            <div className="fg" style={{ gridColumn: '1/-1' }}><label className="fl">Address</label><input type="text" className="fi" {...F('address')} /></div>
            <div className="fg"><label className="fl">Passport / ID</label><input type="text" className="fi" {...F('passport')} /></div>
            <div className="fg"><label className="fl">Nationality</label><input type="text" className="fi" {...F('nationality')} /></div>
            <div className="fg"><label className="fl">Driving licence #</label><input type="text" className="fi" {...F('licence')} /></div>
            <div className="fg"><label className="fl">Licence expiry</label><input type="date" className="fi" {...F('licExpiry')} /></div>
            <div className="fg" style={{ gridColumn: '1/-1' }}><label className="fl">Notes</label><textarea className="fi" rows={2} {...F('notes')} /></div>
          </div>
          <div className="fg">
            <label className="fl">Avatar colour</label>
            <div style={{ display: 'flex', gap: 6 }}>
              {COLORS.map(c => (
                <div key={c} onClick={() => setForm(p => ({ ...p, color: c }))}
                  style={{ width: 24, height: 24, borderRadius: '50%', background: c, cursor: 'pointer', border: `3px solid ${form.color === c ? '#000' : 'transparent'}` }} />
              ))}
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-ghost" onClick={() => closeModal('add-customer')}>Cancel</button>
        <button className="btn btn-primary" onClick={submit}>Add Customer</button>
      </ModalFooter>
    </Modal>
  );
}
